<template>
    <sa-page-layout :btnNewVisible="false" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :linkback="linkback" :showModalLoading="showModalLoading">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Codice Articolo:</label>
                        <b-form-input v-model="filtro.codice" type="search" id="codice" placeholder="Codice"></b-form-input>
                    </b-col>
                    <b-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Barcode:</label>
                        <b-form-input v-model="filtro.barcode" type="search" id="barcode" placeholder="Barcode"></b-form-input>
                    </b-col>
                    <b-col cols="4" xs="4" sm="4" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Descrizione Articolo:</label>
                        <b-form-input v-model="filtro.descrizione" type="search" id="descrizione" placeholder="Descrizione Articolo"></b-form-input>
                    </b-col>
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: -2rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <paperclean-articoli-list-component ref="PapercleanArticoliListComponent" @beforLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></paperclean-articoli-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import PapercleanArticoliListComponent from "../components/PapercleanArticoliListComponent.vue";
export default {
    components: { SaPageLayout, PapercleanArticoliListComponent },
    data() {
        return {
            filtro: { nominativo: "", codiceTipo: "", partitaIva: "", codiceFiscale: "" },
            btnNewVisible: true,
            btnBackVisible: true,
            linkback: "/home",
            pathResource: "/articoli",
            pathResourceTipiAnagrafica: "/dizionariotipi",
            linkedit: "/rsagestioneospiti",
            tipoAnagraficaOptions: [{ codiceTipo: "", descrizioneTipo: "-Seleziona Valore-" }],
            showModalLoading: false,
            listKey: 0,
        };
    },
    mounted() {
        let me = this;
        me.loadTipiAnagrafica();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.PapercleanArticoliListComponent.loadData(me.filtro);
        },
        loadTipiAnagrafica() {
            let me = this;
            let filtro = {};
            filtro.sezioneDizionario = "ANAGRAFICA";
            UtilityMixin.methods.loadDataResources(me.pathResourceTipiAnagrafica, filtro, me.loadDataSuccess, me.loadDataError);
            me.loadData();
        },
        loadDataSuccess(response) {
            let me = this;
            me.tipoAnagraficaOptions = response.data.data.list;
            me.tipoAnagraficaOptions.unshift({ codiceTipo: "", descrizioneTipo: "-Seleziona Valore-" });
        },
        loadDataError(response) {
            console.log(response);
        },

        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onReset() {
            let me = this;
            me.filtro = { nome: null, cognome: null, identificativo: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtro"] = JSON.stringify(me.filtro);
            me.loadData();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtro"] = JSON.stringify(me.filtro);
            me.loadData();
        },
    },
};
</script>

<style></style>
